import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './main/page-not-found/page-not-found.component';
import { authGuard } from './core/guards/auth.guard';
import { MainComponent } from './main/main.component';
import { LoginComponent } from './main/login/login.component';
import { CadastroUsuarioComponent } from './main/cadastro-usuario/cadastro-usuario.component';
import { DefinirSenhaComponent } from './main/definir-senha/definir-senha.component';
import { ExternoComponent } from './main/externo/externo.component';
import { PreferenciaNotificacaoComponent} from './main/notificacao/preferencia-notificacao/preferencia-notificacao.component';

const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: { info: 'home' } },
    component: MainComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./main/main.module').then(m => m.MainModule),
      },
      {
        path: 'preferencias-notificacoes',
        component: PreferenciaNotificacaoComponent,
        data: { breadcrumb: 'Preferências de Notificação' }
      }
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'cadastro-usuario',
    component: CadastroUsuarioComponent,
  },
  {
    path: 'definir-senha',
    component: DefinirSenhaComponent,
  },
  {
    path: 'externo',
    component: ExternoComponent,
  },
  {
    path: 'termos-de-uso',
    component: PageNotFoundComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
